// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Qq9F","title":"Info_title__pBEwD","links":"Info_links__2AIo9","link":"Info_link__oX5F7","logo":"Info_logo__1Fcl2"};